const MIN_VIEWPORT_FOR_CAROUSEL = 1200;

const isDesktop = (): boolean => {
  return typeof window !== 'undefined' && window.innerWidth >= MIN_VIEWPORT_FOR_CAROUSEL;
};

export default isDesktop;
